import Head from "next/head";
import LoadingSpinner from "@components/misc/LoadingSpinner";
import styled from "styled-components";
import links from "@utils/constants/links";

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 50vh;
`;
const Home = () => (
  <>
    <Head>
      <title>Neofin</title>
      <meta name="description" content="Home page of the app" />
    </Head>
    <LoadingContainer>
      <LoadingSpinner size="lg" />
    </LoadingContainer>
  </>
);

Home.privatePage = true;
Home.layout = "NotLogged";
Home.loggedRedirect = links.dashboard;

export default Home;
